/*!
 * plid-advisor.js — UI-Schicht des nativen Kaufberaters (Impulse-Theme).
 *
 * ORIGINALGETREUE Reproduktion der Oberfläche aus buildmaster/advisor/demo.html
 * (Markup, Klassennamen, ICONS, TILE_META, guessOptIcon, TRUST, alle Render-
 * Funktionen). NUR die Datenschicht ist ersetzt — statt Server-Fetches:
 *   - Beratung/Mengen/Gates/FAQ/Eignung → PlidAdvisorCore (Lookup, aus advisor-data.json)
 *   - Live-Preise + €-Ersparnis → Shopifys öffentliche /products.json (kein Key)
 *   - "In den Warenkorb" → POST /cart/add.js (same-origin, nativ)
 * KEINE Geschäftsregeln hier. Kein iframe, kein Server.
 *
 * Mount: Element mit class "plid-advisor" + data-advisor-src (JSON-URL),
 * optional data-fall (Direkt-Einsprung), data-products-url, data-cart-*.
 */
(function () {
  "use strict";

  // Linien-Icons (stroke=currentColor via CSS) — 1:1 aus demo.html.
  var ICONS = {
    wall: '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="1"/><path d="M3 10h18M3 15h18M9 4v6M15 10v5M9 15v5"/></svg>',
    floor: '<svg viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="12" rx="1"/><path d="M8 6v12M12 6v12M16 6v12"/></svg>',
    facade: '<svg viewBox="0 0 24 24"><path d="M4 11l8-6 8 6"/><path d="M6 10v9h12v-9"/><path d="M10 19v-5h4v5"/></svg>',
    wood: '<svg viewBox="0 0 24 24"><path d="M12 3l5 7h-3l4 6H6l4-6H7z"/><path d="M12 16v5"/></svg>',
    radiator: '<svg viewBox="0 0 24 24"><path d="M6 7v10M10 7v10M14 7v10M18 7v10"/><path d="M4 9h16M4 15h16"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4-3 7-7 9-4-2-7-5-7-9V6z"/></svg>',
    droplet: '<svg viewBox="0 0 24 24"><path d="M12 3c4 5 6 8 6 11a6 6 0 01-12 0c0-3 2-6 6-11z"/></svg>',
    chair: '<svg viewBox="0 0 24 24"><path d="M7 4v8M17 4v8M5 8h14M7 12h10M8 12v8M16 12v8"/></svg>',
    boat: '<svg viewBox="0 0 24 24"><path d="M3 15h18l-2 5H5zM12 3v9M12 6l6 2-6 2"/></svg>',
    bug: '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="13" rx="4" ry="5"/><path d="M12 8V5M9 6l1 2M15 6l-1 2M5 11H3M5 15H3M21 11h-2M21 15h-2"/></svg>',
    stairs: '<svg viewBox="0 0 24 24"><path d="M4 20h4v-4h4v-4h4v-4h4"/></svg>',
    brush: '<svg viewBox="0 0 24 24"><path d="M14 3l7 7-4 4-7-7zM10 7l-6 6c-1 1-1 3 0 4s3 1 4 0l6-6"/></svg>',
    magnet: '<svg viewBox="0 0 24 24"><path d="M6 4v8a6 6 0 0012 0V4M6 4h4v8a2 2 0 004 0V4h4"/></svg>',
    tile: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="1"/><path d="M12 3v18M3 12h18"/></svg>',
    spark: '<svg viewBox="0 0 24 24"><path d="M12 4l1.8 5.2L19 11l-5.2 1.8L12 18l-1.8-5.2L5 11l5.2-1.8z"/></svg>',
    calc: '<svg viewBox="0 0 24 24"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 11h2.5M13.5 11H16M8 15h2.5M8 18h2.5M14 15v3"/></svg>',
    dot: '<svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="M4 12l5 5L20 6"/></svg>',
    flame: '<svg viewBox="0 0 24 24"><path d="M12 3c1 3 4 4 4 8a4 4 0 01-8 0c0-1.6.6-2.7 1.6-3.6C9.6 8 11 6.6 12 3z"/></svg>',
    box: '<svg viewBox="0 0 24 24"><path d="M12 3l8 4v10l-8 4-8-4V7z"/><path d="M4 7l8 4 8-4M12 11v10"/></svg>',
    layers: '<svg viewBox="0 0 24 24"><path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/></svg>',
    grain: '<svg viewBox="0 0 24 24"><circle cx="6" cy="7" r="1"/><circle cx="12" cy="6" r="1"/><circle cx="18" cy="8" r="1"/><circle cx="8" cy="13" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="6" cy="18" r="1"/><circle cx="12" cy="18" r="1"/><circle cx="18" cy="16" r="1"/></svg>',
    swatch: '<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="12" cy="12" r="3"/></svg>',
    factory: '<svg viewBox="0 0 24 24"><path d="M3 21V10l6 4V10l6 4V7l6 3v11z"/><path d="M3 21h18"/></svg>',
    medal: '<svg viewBox="0 0 24 24"><circle cx="12" cy="14" r="5"/><path d="M9 9.5L7 3M15 9.5L17 3M10 4h4"/></svg>',
    ruler: '<svg viewBox="0 0 24 24"><path d="M4 8l12 12 4-4L8 4z"/><path d="M9 7l1.6 1.6M12 10l1.6 1.6M15 13l1.6 1.6"/></svg>',
  };

  // Option-Text „Label — Detail" / „Label (Detail)" → {label, sub} — 1:1 aus demo.
  function splitOpt(text) {
    var dash = text.split(" — ");
    if (dash.length > 1) return { label: dash[0], sub: dash.slice(1).join(" — ") };
    var p = text.indexOf(" (");
    if (p > 0 && text.trim().slice(-1) === ")") return { label: text.slice(0, p), sub: text.slice(p + 2, -1) };
    return { label: text, sub: "" };
  }

  // Passendes Icon je Option per Stichwort — 1:1 aus demo (Priorität = Reihenfolge).
  function guessOptIcon(text) {
    var t = text.toLowerCase().replace(/\([^)]*\)/g, " ");
    if (/unsicher|nicht sicher|anderes|weiß nicht|weiss nicht|sonst/.test(t)) return "spark";
    if (/heizk/.test(t)) return "radiator";
    if (/^trocken\b/.test(t) || (/^nein/.test(t) && /trocken/.test(t))) return "check";
    if (/schimmel|nikotin|\bflecken\b/.test(t)) return "shield";
    if (/feucht|nass|wasser|abdicht|salzausbl/.test(t)) return "droplet";
    if (/pool|becken|teich/.test(t)) return "droplet";
    if (/garage|auto|reifen|werkstatt|lager|stellplatz/.test(t)) return "floor";
    if (/fassade|außen|aussen|wetter|bewittert|schlagregen/.test(t)) return "facade";
    if (/fliese/.test(t)) return "tile";
    if (/möbel|moebel|schrank|tisch/.test(t)) return "chair";
    if (/boot|rumpf/.test(t)) return "boat";
    if (/hitze|hitzebest/.test(t)) return "flame";
    if (/komplett|\bset\b/.test(t)) return "box";
    if (/holz|lasier|lackier|\böl\b|\boel\b|zaun|garten/.test(t)) return "wood";
    if (/robust|glatt|glänzend|glaenzend|versiegelt|\bdicht\b/.test(t)) return "layers";
    if (/anstrich|gestrichen|lackfarbe|abblätter|abblaetter/.test(t)) return "brush";
    if (/saugend|\broh\b|roher|mineralisch|kalk|leimfarbe/.test(t)) return "grain";
    if (/beton|sockel|mauer/.test(t)) return "wall";
    if (/boden|keller|estrich|begehbar|balkon|terrasse/.test(t)) return "floor";
    if (/innen|wohn|zimmer|decke|flur|treppenhaus|putz|\bwand\b/.test(t)) return "wall";
    if (/bad|küche|kuche/.test(t)) return "droplet";
    if (/standard|normal|geruchsarm|vergilbung/.test(t)) return "check";
    return "swatch";
  }

  // Kurz-Label + Unterzeile + Icon je Fall — 1:1 aus demo.
  var TILE_META = {
    innenwand_streichen: { label: "Innenwand & Decke", sub: "Wohnraum, Bad, Flur", icon: "wall" },
    boden_beschichten: { label: "Bodenbeschichtung", sub: "Garage, Keller, Werkstatt", icon: "floor" },
    fassade_streichen: { label: "Fassade", sub: "Außenwand, wetterfest", icon: "facade" },
    holz_lasieren: { label: "Holz lasieren", sub: "Zaun, Gartenholz", icon: "wood" },
    heizkoerper: { label: "Heizkörper", sub: "geruchsarm, robust", icon: "radiator" },
    schimmel_sanierung: { label: "Schimmel", sub: "beseitigen & überstreichen", icon: "shield" },
    pool: { label: "Pool / Becken", sub: "Beton, GFK, Stahl", icon: "droplet" },
    moebel_lackieren: { label: "Möbel lackieren", sub: "Schränke, Tische", icon: "chair" },
    boot_lackieren: { label: "Boot", sub: "Rumpf & Deck", icon: "boat" },
    holzwurm: { label: "Holzwurm", sub: "Holz behandeln", icon: "bug" },
    aussenholz_deckend: { label: "Außenholz deckend", sub: "wetterfest, deckend", icon: "wood" },
    holz_oelen: { label: "Holz ölen", sub: "Terrasse, Gartenholz", icon: "wood" },
    treppe_parkett: { label: "Treppe & Parkett", sub: "versiegeln", icon: "stairs" },
    flecken_isolieren: { label: "Flecken isolieren", sub: "Nikotin, Wasser", icon: "brush" },
    magnetwand: { label: "Magnetwand", sub: "Magnetfarbe", icon: "magnet" },
    sockel_dach: { label: "Sockel & Dach", sub: "Sockel, Dachüberstand", icon: "facade" },
    fliesen_ueberstreichen: { label: "Fliesen überstreichen", sub: "Bad, Küche", icon: "tile" },
    balkon_abdichten: { label: "Balkon & Terrasse", sub: "Boden außen", icon: "floor" },
  };
  function tileMeta(f) {
    return TILE_META[f.case_id] || { label: f.titel, sub: (f.intro || "").slice(0, 40), icon: "spark" };
  }

  // Vertrauens-Anker — 1:1 aus demo.
  var TRUST = [
    ["factory", "Direkt vom Hersteller"],
    ["medal", "Made in Germany"],
    ["ruler", "Passgenaue Menge"],
    ["check", "Kostenlos & unverbindlich"],
  ];

  function initMount(root) {
    if (!root || root.__plidAdvisorInit) return;
    root.__plidAdvisorInit = true;

    var dataSrc = root.getAttribute("data-advisor-src");
    var productsUrl = root.getAttribute("data-products-url") || "/products.json";
    var cartAddUrl = root.getAttribute("data-cart-add-url") || "/cart/add.js";
    if (!/\.js$/.test(cartAddUrl)) cartAddUrl += ".js";   // routes.cart_add_url liefert "/cart/add" ohne .js
    var cartUrl = root.getAttribute("data-cart-url") || "/cart";
    var checkoutUrl = root.getAttribute("data-checkout-url") || "/checkout";
    var deepFall = root.getAttribute("data-fall") || null;
    // CRO 13.07.: Deep-Link von den Startseiten-Kacheln — mehrere Wege, damit es auch in der
    // Shopify-Vorschau funktioniert (die ?preview_theme_id anhängt und Custom-Query wegwerfen kann):
    // 1) ?fall=<case_id>  2) #fall=<case_id> (Hash, nie serverseitig gestrippt)  3) sessionStorage (Klick-Merker).
    if (!deepFall) { try { deepFall = new URL(window.location.href).searchParams.get("fall") || null; } catch (e) {} }
    if (!deepFall) { try { var _h = (window.location.hash || "").match(/fall=([a-z0-9_]+)/i); if (_h) deepFall = _h[1]; } catch (e) {} }
    if (!deepFall) { try { deepFall = sessionStorage.getItem("plid_advisor_fall") || null; } catch (e) {} }
    try { sessionStorage.removeItem("plid_advisor_fall"); } catch (e) {}
    // Optionaler Aktions-Rabattcode (Zeit-Test, z.B. "Kaufberater5"): wird beim
    // Kauf automatisch angehängt. Leer/nicht gesetzt = aus (nichts wird angehängt).
    // Abschalten nach dem Test = Attribut data-discount-code im Snippet leeren
    // ODER den Code im Shopify-Admin löschen. Nur A-Z/0-9/-/_ zugelassen.
    var discountCode = (root.getAttribute("data-discount-code") || "").trim().replace(/[^A-Za-z0-9_-]/g, "");
    var discountPercent = parseFloat(root.getAttribute("data-discount-percent")) || 0;   // nur Anzeige „zusätzlich −X %"

    var Core = window.PlidAdvisorCore;
    if (!Core) { root.innerHTML = '<div class="card"><div class="box stop">Beratung nicht geladen (Core fehlt).</div></div>'; return; }

    // Gerüst (head/trust/progress/stage/foot) wie demo.
    root.innerHTML =
      '<div class="head"><p class="eyebrow">Plid Farb- & Materialberatung</p>' +
      '<h2>Was möchtest du streichen oder beschichten?</h2>' +
      '<p>Sag es uns in eigenen Worten — wir finden das passende System und rechnen dir die Menge aus.</p></div>' +
      '<div class="trust" id="pa-trust"></div>' +
      '<div class="progress" id="pa-progress"></div>' +
      '<div id="pa-stage" class="card"><div class="spin">Lädt…</div></div>' +
      '<div class="foot">Kostenlose Mengenberatung · echte Plid-Preise · unverbindliche Empfehlung</div>';

    var $stage = root.querySelector("#pa-stage");
    var $progress = root.querySelector("#pa-progress");
    var $trust = root.querySelector("#pa-trust");

    var engine = null;
    var priceMap = {};   // variant_id → {price, compareAt}
    var booted = false;  // Impression („start") nur einmal je Mount feuern
    var state = {};
    function resetState() {
      state = { caseId: null, schema: null, step: 0, answers: {}, area: null, coats: null,
                mit_werkzeug: false, color: null, colors: [], swatches: [], colorCategory: null,
                res: null, lines: [] };
    }
    resetState();

    // --- Ergebnis merken (Browser-Zurück / Popup neu öffnen) ----------------
    // Nur für die aktuelle Browser-Sitzung (sessionStorage). Gespeichert wird der
    // schlanke Auswahl-Zustand (Fall + Antworten + Fläche/Anstriche/Farbe) — daraus
    // rechnet der Kern beim Zurückkommen dasselbe Ergebnis neu. So ist das Ergebnis
    // nach "Direkt zur Kasse" + Browser-Zurück wieder da, statt auf die Startkacheln
    // zu fallen. KEIN Auto-Öffnen des Popups (Chef-Wahl 12.07.).
    var SNAP_KEY = "plidAdvisor:last";
    function saveSnap() {
      try {
        sessionStorage.setItem(SNAP_KEY, JSON.stringify({
          v: 1, caseId: state.caseId, answers: state.answers, area: state.area,
          coats: state.coats, mit_werkzeug: state.mit_werkzeug, color: state.color,
        }));
      } catch (e) {}
    }
    function loadSnap() {
      try {
        var raw = sessionStorage.getItem(SNAP_KEY);
        if (!raw) return null;
        var s = JSON.parse(raw);
        return (s && s.v === 1 && s.caseId) ? s : null;
      } catch (e) { return null; }
    }
    function clearSnap() { try { sessionStorage.removeItem(SNAP_KEY); } catch (e) {} }

    // Ergebnis aus einem Schnappschuss wiederherstellen (über die normale Kette,
    // damit Farbwähler/Swatches korrekt rekonstruiert werden).
    function restoreResult(snap) {
      resetState();
      state.caseId = snap.caseId;
      state.schema = engine.schema(snap.caseId);
      if (!state.schema) return false;
      state.answers = snap.answers || {};
      state.area = snap.area;
      state.coats = snap.coats;
      state.mit_werkzeug = !!snap.mit_werkzeug;
      state.color = snap.color || null;
      if (state.area == null) return false;   // ohne Fläche kein reproduzierbares Ergebnis
      maybeAskColor();   // rekonstruiert colorCategory + swatches, ruft submit() → renderResult()
      return true;
    }

    var eur = function (n) { return n == null ? "" : n.toFixed(2).replace(".", ",") + " €"; };
    var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); };
    function byId(id) { return root.querySelector("#" + id); }
    function each(nodes, fn) { Array.prototype.forEach.call(nodes, fn); }

    // --- Live-Preise (öffentliche /products.json) ---------------------------
    function loadPrices() {
      return fetchJSON(productsUrl + (productsUrl.indexOf("?") === -1 ? "?limit=250" : "")).then(function (pj) {
        (pj.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            if (v && v.id != null) priceMap[String(v.id)] = {
              price: parseFloat(v.price),
              compareAt: v.compare_at_price ? parseFloat(v.compare_at_price) : null,
            };
          });
        });
      }).catch(function () { /* offline → Snapshot-Preise */ });
    }
    function livePrice(variantId, fallback) {
      var pm = variantId && priceMap[String(variantId)];
      return (pm && !isNaN(pm.price)) ? pm.price : fallback;
    }
    function fetchJSON(url) {
      return fetch(url, { headers: { "Accept": "application/json" } }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      });
    }

    // --- Boot ---------------------------------------------------------------
    fetchJSON(dataSrc).then(function (data) {
      engine = Core.createEngine(data);
      renderTrust();
      loadPrices();
      boot();
    }).catch(function (e) {
      $stage.innerHTML = '<div class="box stop">Beratung nicht verfügbar: ' + esc(String(e)) + "</div>";
    });

    function boot() {
      renderTrust();
      if (!booted) { booted = true; try { paTrack("start"); } catch (e) {} }
      if (deepFall && engine.getFall(deepFall)) { selectCase(deepFall); return; }
      // Zurück aus Kasse/Warenkorb: gemerktes Ergebnis wiederherstellen statt Startkacheln.
      var snap = loadSnap();
      if (snap && engine.getFall(snap.caseId)) { try { if (restoreResult(snap)) return; } catch (e) {} }
      renderEntry();
    }

    function renderTrust() {
      if (!$trust) return;
      $trust.innerHTML = TRUST.map(function (t) { return '<span>' + ICONS[t[0]] + esc(t[1]) + "</span>"; }).join("");
    }

    function setProgress(n) {
      var total = state.schema ? state.schema.fragen.length : 4;
      var out = "";
      for (var i = 0; i < total; i++) out += '<i class="' + (i <= n ? "on" : "") + '"></i>';
      $progress.innerHTML = out;
    }

    // --- Einstieg (nur Kachel-Grid; KEIN Freitext-Suchfeld) -----------------
    // Chef-Entscheidung: der dumme Stichwort-Abgleich (intent) wirkt unintelligent;
    // echtes Sprachverständnis kommt erst in Etappe 2 (KI/Server). Darum ist das
    // Icon-Grid der beratbaren Fälle der EINZIGE Einstieg. Statt „Etwas anderes →
    // Freitext" nur ein dezenter Hinweis (kein Freitext-Berater).
    function renderEntry(msg) {
      resetState();
      clearSnap();   // bewusster Neustart → gemerktes Ergebnis verwerfen
      setProgress(0);
      var faelle = engine.faelle;
      var h = '<p class="q">Was möchtest du streichen oder beschichten?</p>' +
        '<p class="hint">Wähl dein Vorhaben — wir finden das passende Produkt und rechnen die Menge aus.</p>';
      if (msg) h += '<div class="box warn">' + esc(msg) + "</div>";
      h += '<div class="tiles">';
      faelle.forEach(function (f) {
        var m = tileMeta(f);
        h += '<button class="tile" data-c="' + esc(f.case_id) + '">' +
          '<span class="ic">' + (ICONS[m.icon] || ICONS.spark) + "</span>" +
          '<span class="tx"><span class="tt">' + esc(m.label) + "</span>" +
          (m.sub ? '<span class="st">' + esc(m.sub) + "</span>" : "") + "</span></button>";
      });
      h += "</div>";
      // Dezenter Hinweis statt Freitext-Kachel — kein Stichwort-„Berater".
      h += '<p class="foot" style="margin-top:14px;text-align:left">Nicht dabei? ' +
        'Nutze die Suche im Shop oder <a href="/pages/contact" style="color:var(--plid);font-weight:600">kontaktiere uns</a> — wir helfen persönlich weiter.</p>';
      $stage.innerHTML = h;
      each($stage.querySelectorAll(".tile[data-c]"), function (b) { b.onclick = function () { selectCase(b.getAttribute("data-c")); }; });
    }

    function selectCase(caseId) {
      resetState();
      state.caseId = caseId;
      state.schema = engine.schema(caseId);
      if (!state.schema) { renderEntry("Konnte den Fall nicht laden."); return; }
      try { paTrack("thema_gewaehlt", caseId); } catch (e) {}
      render();
    }

    // --- Frage-Schritte -----------------------------------------------------
    function render() {
      setProgress(state.step);
      var q = state.schema.fragen[state.step];
      if (q.typ === "number") return renderNumber(q);
      var opts = q.optionen.map(function (o) {
        var s = splitOpt(o.text), ic = guessOptIcon(o.text);
        return '<button class="tile qt" data-v="' + esc(o.value) + '"' + (o.terminal ? ' data-terminal="1"' : "") + ">" +
          '<span class="ic">' + (ICONS[ic] || ICONS.swatch) + "</span>" +
          '<span class="tx"><span class="tt">' + esc(s.label) + "</span>" +
          (s.sub ? '<span class="st">' + esc(s.sub) + "</span>" : "") + "</span></button>";
      }).join("");
      $stage.innerHTML = '<p class="q">' + esc(q.text) + "</p>" +
        (q.hinweis ? '<p class="hint">' + esc(q.hinweis) + "</p>" : "") + '<div class="qtiles">' + opts + "</div>" +
        '<button class="btn sec" id="pa-back" style="margin-top:10px">' + (state.step === 0 ? "Anderes Vorhaben" : "Zurück") + "</button>";
      each($stage.querySelectorAll(".tile.qt"), function (b) {
        b.onclick = function () { answer(q.id, b.getAttribute("data-v"), b.getAttribute("data-terminal")); };
      });
      var bk = byId("pa-back");
      if (bk) bk.onclick = function () { if (state.step > 0) { state.step--; render(); } else renderEntry(); };
    }

    function answer(id, val, terminal) {
      state.answers[id] = val;
      try { paTrack("frage_beantwortet", state.caseId + ":q" + (state.step + 1)); } catch (e) {}
      if (terminal) return submit();
      state.step++;
      render();
    }

    // --- Slider-Mengenrechner (Fläche gekappt auf 200, Tippfeld voll) -------
    function renderNumber(q) {
      setProgress(state.step);
      var cov = state.schema.coverage_hint || 10;
      var sMax = Math.min(q.max, 200);                       // Slider praxisnah kappen
      var start = Math.min(Math.max(state.area || 12, q.min), q.max);  // vorherige Fläche erhalten (Zurück), sonst sinnvoller Startwert
      var coats0 = state.coats || state.schema.coats_default || 2;
      var werkTgl = state.schema.werkzeug_option
        ? '<label class="toggle"><input type="checkbox" id="pa-werk"> Maler-Set (6-tlg Streichset) dazu?</label>' : "";
      $stage.innerHTML = '<p class="q">' + esc(q.text) + "</p>" +
        '<div class="calc">' +
          '<div class="ce">' + ICONS.calc + " Mengenrechner</div>" +
          '<div class="srow">' +
            '<div class="lab"><span>Fläche</span><span><input class="val" type="number" id="pa-area" ' +
              'min="' + q.min + '" max="' + q.max + '" value="' + start + '"> m²</span></div>' +
            '<input type="range" id="pa-areaR" min="' + q.min + '" max="' + sMax + '" value="' + Math.min(start, sMax) + '">' +
            '<div class="ticks"><span>' + q.min + "</span><span>" + Math.round(sMax / 3) + "</span>" +
              "<span>" + Math.round(sMax * 2 / 3) + "</span><span>" + sMax + (sMax < q.max ? "+" : "") + "</span></div>" +
          "</div>" +
          '<div class="srow">' +
            '<div class="lab"><span>Anstriche</span><span><b class="val" id="pa-coatsV">' + coats0 + "</b> ×</span></div>" +
            '<input type="range" id="pa-coatsR" min="1" max="4" value="' + coats0 + '">' +
            '<div class="ticks"><span>1×</span><span>2×</span><span>3×</span><span>4×</span></div>' +
            '<div class="sub2">In der Regel reichen 2 Anstriche.</div>' +
          "</div>" +
          '<div class="res"><div><div class="lb">Du brauchst etwa</div><div class="big" id="pa-liters">–</div></div>' +
            '<div class="hint2">~' + eur0(cov) + " m² pro Liter</div></div>" +
        "</div>" +
        werkTgl +
        '<button class="btn" id="pa-go" style="margin-top:14px">Ergebnis ansehen →</button>' +
        '<button class="btn sec" id="pa-back" style="margin-top:10px">Zurück</button>';
      var area = byId("pa-area"), areaR = byId("pa-areaR"), coatsR = byId("pa-coatsR"), coatsV = byId("pa-coatsV");
      var clamp = function (v) { return Math.min(Math.max(v || q.min, q.min), q.max); };
      function recalc() {
        var a = clamp(parseFloat(area.value)), c = parseInt(coatsR.value, 10) || 2;
        byId("pa-liters").textContent = litersLabel(a / cov * c);
      }
      areaR.oninput = function () { area.value = areaR.value; recalc(); };
      area.oninput = function () { areaR.value = Math.min(clamp(parseFloat(area.value)), sMax); recalc(); };
      coatsR.oninput = function () { coatsV.textContent = coatsR.value; recalc(); };
      recalc();
      byId("pa-back").onclick = function () { if (state.step > 0) { state.step--; render(); } else renderEntry(); };
      byId("pa-go").onclick = function () {
        var a = clamp(parseFloat(area.value));
        if (!a) { area.focus(); return; }
        state.area = a; state.coats = parseInt(coatsR.value, 10) || 2;
        var w = byId("pa-werk"); state.mit_werkzeug = w ? w.checked : false;
        try { paTrack("menge_berechnet", state.caseId); } catch (e) {}
        maybeAskColor();
      };
    }
    function litersLabel(l) {
      if (l <= 0) return "–";
      var v = Math.round(l * 10) / 10;
      var s = (Math.round(v * 10) % 10 === 0) ? String(Math.round(v)) : v.toFixed(1).replace(".", ",");
      return s + " Liter";
    }
    function eur0(n) { return String(Math.round(n)); }

    // Farbton hängt am gewählten Produkt → über den Rezept-Kern das farbführende
    // catalog_key finden (aus dem Ergebnis) + dessen Swatches; dann submit.
    function maybeAskColor() {
      var probe = evaluate();
      state.colorCategory = null; state.swatches = [];
      if (probe && probe.line_items) {
        for (var i = 0; i < probe.line_items.length; i++) {
          var sw = engine.swatchesFor(state.caseId, probe.line_items[i].catalog_key);
          if (sw && sw.length) { state.colorCategory = probe.line_items[i].catalog_key; state.swatches = sw; break; }
        }
      }
      state.colors = state.swatches.map(function (s) { return s.name; });
      submit();
    }

    function evaluate() {
      var answers = {};
      for (var k in state.answers) if (Object.prototype.hasOwnProperty.call(state.answers, k)) answers[k] = state.answers[k];
      answers.area_m2 = state.area;
      answers.coats = state.coats || state.schema.coats_default || 2;
      answers.mit_werkzeug = state.mit_werkzeug;
      if (state.color) answers.color = state.color;
      try { return engine.evaluate(state.caseId, answers); } catch (e) { return null; }
    }

    function submit() {
      var res = evaluate();
      if (!res) { $stage.innerHTML = '<p class="box stop">Da ging etwas schief. Bitte nochmal.</p>'; return; }
      result(res);
    }

    // --- Ergebnis -----------------------------------------------------------
    function result(res) {
      if (res.weiter_case_id) {
        $stage.innerHTML = '<p class="q">' + esc(res.ueberschrift) + '</p><p class="lead">' + esc(res.nachricht) + "</p>" +
          '<button class="btn" id="pa-weiter">Ja, weiter zur passenden Beratung</button>' + again();
        byId("pa-weiter").onclick = function () { selectCase(res.weiter_case_id); };
        wire(); return;
      }
      // CRO 13.07.: "Etwas anderes / ich bin unsicher" ist KEINE Sackgasse — der Kunde ist nur
      // unsicher, nicht in einem aussichtslosen Fall. Darum hier ein hilfreicher Abschluss
      // (persönliche Beratung + neue Auswahl) statt der "wir empfehlen nichts"-Box.
      if (res.status === "unsicher_produkt") {
        var fallTitel = "";
        try { fallTitel = (engine.getFall(state.caseId) || {}).titel || state.caseId || ""; } catch (e) {}
        var inpStyle = "display:block;width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid rgba(36,41,91,.22);border-radius:8px;margin-bottom:10px;font:inherit";
        $stage.innerHTML = '<p class="q">' + esc(res.ueberschrift) + '</p><p class="lead">' + esc(res.nachricht) + "</p>" +
          '<form class="pa-contact" id="pa-contact" method="post" action="/contact#pa-contact" accept-charset="UTF-8" style="margin-top:12px">' +
            '<input type="hidden" name="form_type" value="contact">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="contact[Projekt]" value="' + esc(fallTitel) + '">' +
            '<input type="hidden" name="contact[Quelle]" value="Kaufberater (unsicher)">' +
            '<label for="pa-c-body" style="display:block;font-weight:600;margin:0 0 6px">Beschreib kurz dein Vorhaben</label>' +
            '<textarea id="pa-c-body" name="contact[body]" rows="4" required placeholder="z. B. Kellerboden, ca. 20 m², leicht feucht – was passt?" style="' + inpStyle + '"></textarea>' +
            '<input id="pa-c-mail" type="email" name="contact[email]" required placeholder="Deine E-Mail für die Antwort" style="' + inpStyle + '">' +
            '<button class="btn" type="submit">An unsere Beratung senden</button>' +
          '</form>' +
          '<div id="pa-contact-done" class="box" style="display:none"><h3>Danke – wir melden uns!</h3>' +
          'Deine Nachricht ist bei uns. Wir antworten dir zeitnah per E-Mail mit einer persönlichen Empfehlung.</div>' +
          again();
        wire();
        (function () {
          var f = byId("pa-contact"); if (!f) return;
          f.addEventListener("submit", function (ev) {
            ev.preventDefault();
            var btn = f.querySelector("button[type=submit]");
            if (btn) { btn.disabled = true; btn.textContent = "Wird gesendet …"; }
            fetch("/contact", { method: "POST", body: new FormData(f), headers: { "Accept": "text/html" } })
              .then(function () {
                f.style.display = "none";
                var d = byId("pa-contact-done"); if (d) d.style.display = "";
                try { paTrack("beratung_kontakt_gesendet"); } catch (e) {}
              })
              .catch(function () { f.submit(); }); // Fallback: nativer Submit (Shopify sendet trotzdem)
          });
        })();
        return;
      }
      if (res.ehrlicher_pfad) {
        $stage.innerHTML = '<p class="q">' + esc(res.ueberschrift) + '</p><p class="lead">' + esc(res.nachricht) + "</p>" +
          '<div class="box stop"><h3>Ehrlich gesagt: erst das klären.</h3>' +
          "Wir empfehlen dir hier bewusst nichts — das würde nicht halten.</div>" + again();
        wire(); return;
      }
      state.res = res;
      state.lines = (res.line_items || []).map(function (li) {
        return {
          position: li.position, optional: li.optional, note: li.note || "",
          unit: parseBase(li.quantity_label),
          unit_price: livePrice(li.variant_id, li.unit_price),
          count: li.pack_count || 1,
          cartId: (li.cart && li.cart[0] ? li.cart[0].id : null),
          catalog_key: li.catalog_key || "", image: li.image || "", handle: li.handle || "", removed: false,
        };
      });
      renderResult();
    }

    function parseBase(label) { var s = String(label || ""); var i = s.indexOf("× "); return i >= 0 ? s.slice(i + 2) : s; }
    function activeLines() { return state.lines.filter(function (l) { return !l.removed; }); }

    // Mengenrabatt-Stufen aus dem Kern (engine.volumeTiers) — nur Anzeige; Shopify rechnet real.
    function tiers() { return engine ? engine.volumeTiers : [{ min: 6, rate: .10 }, { min: 3, rate: .05 }]; }
    function lineRate(l) { var ts = tiers(); for (var i = 0; i < ts.length; i++) { if (l.count >= ts[i].min) return ts[i].rate; } return 0; }
    function r2(n) { return Math.round(n * 100) / 100; }
    function lineBase(l) { return r2(l.count * l.unit_price); }
    function lineTotal(l) { return r2(l.count * l.unit_price * (1 - lineRate(l))); }
    function lineSaved(l) { return r2(lineBase(l) - lineTotal(l)); }
    function grandTotal() { return r2(activeLines().reduce(function (s, l) { return s + lineTotal(l); }, 0)); }
    function totalSaved() { return r2(activeLines().reduce(function (s, l) { return s + lineSaved(l); }, 0)); }
    // properties._kaufberater: verstecktes (Unterstrich = kundenunsichtbar) Merkmal je Position,
    // damit im Bestell-Admin sichtbar ist, WELCHE Artikel aus der Beratung kamen.
    function cartItems() { return activeLines().filter(function (l) { return l.cartId; }).map(function (l) { return { id: l.cartId, quantity: l.count, properties: { "_kaufberater": "empfohlen" } }; }); }
    function priceCell(l) {
      var saved = lineSaved(l);
      if (saved > 0) {
        return '<div class="price"><span class="was">' + eur(lineBase(l)) + "</span>" +
          "<span>" + eur(lineTotal(l)) + "</span>" +
          '<span class="save">Du sparst ' + eur(saved) + "</span></div>";
      }
      return '<div class="price">' + eur(lineTotal(l)) + "</div>";
    }

    function renderResult() {
      var res = state.res;
      saveSnap();   // Ergebnis für Browser-Zurück / Popup-Wiederöffnen merken (Sitzung)
      if (!state._tracked) { state._tracked = true; paTrack("beratung_genutzt"); }
      var h = '<p class="q">' + esc(res.ueberschrift) + '</p><p class="lead">' + esc(res.nachricht) + "</p>";
      var hasColors = state.swatches && state.swatches.length;
      var activeColor = state.color || (hasColors ? state.swatches[0].name : null);
      h += '<div class="plan">';
      state.lines.forEach(function (l, i) {
        if (l.removed) return;
        var badge = l.optional ? '<span class="badge opt">optional</span>' : '<span class="badge pf">Pflicht</span>';
        var showColor = hasColors && state.colorCategory && l.catalog_key === state.colorCategory;
        var colorSel = "";
        if (showColor) {
          colorSel = '<div class="linecolor"><span class="lbl q2">Farbton wählen:</span><div class="swatches">' +
            state.swatches.map(function (s) {
              var on = (s.name === activeColor) ? " on" : "";
              if (s.hex) {
                return '<button class="swatch' + on + '" data-color="' + esc(s.name) + '" title="' + esc(s.name) + '">' +
                  '<span class="chip" style="background:' + esc(s.hex) + '"></span>' +
                  '<span class="nm">' + esc(s.name) + "</span></button>";
              }
              if (s.image) {
                return '<button class="swatch' + on + '" data-color="' + esc(s.name) + '" title="' + esc(s.name) + '">' +
                  '<img src="' + esc(s.image) + '" alt="' + esc(s.name) + '" loading="lazy">' +
                  '<span class="nm">' + esc(s.name) + "</span></button>";
              }
              return '<button class="swatch noimg' + on + '" data-color="' + esc(s.name) + '">' + esc(s.name) + "</button>";
            }).join("") + "</div></div>";
        }
        // Produktlink: Bild + Name führen auf die Produktseite (neuer Tab, damit die
        // Beratung erhalten bleibt). Ohne handle (z.B. Zubehör) bleibt es unverlinkt.
        var purl = l.handle ? ("/products/" + l.handle) : "";
        var img = l.image ? '<img class="thumb" src="' + esc(l.image) + '" alt="" loading="lazy">' : "";
        var thumb = (img && purl)
          ? '<a class="thumb-l" href="' + esc(purl) + '" target="_blank" rel="noopener" title="Produkt ansehen">' + img + "</a>"
          : img;
        var pname = purl
          ? '<a class="plink" href="' + esc(purl) + '" target="_blank" rel="noopener">' + esc(l.position) + "</a>"
          : esc(l.position);
        h += '<div class="li">' + thumb + '<div class="info">' +
          '<div class="prow">' +
            '<button class="rm" data-rm="' + i + '" aria-label="Diese Position entfernen" title="Diese Position entfernen">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 4h4M6 7l1 13h10l1-13M10 11v5M14 11v5"/></svg>' +
              '<span class="rm-tx">Entfernen</span></button>' +
            priceCell(l) +
            '<div class="p">' + pname + badge + "</div>" +
          "</div>" +
          '<div class="q2"><span class="stepper">' +
            '<button data-dec="' + i + '" aria-label="weniger">−</button>' +
            "<b>" + l.count + "×</b> " + esc(l.unit) +
            '<button data-inc="' + i + '" aria-label="mehr">+</button></span>' +
            (l.note ? " · " + esc(l.note) : "") + "</div>" +
          colorSel +
        "</div></div>";
      });
      if (!activeLines().length) h += '<div class="li"><div class="q2">Alle Positionen entfernt.</div></div>';
      var saved = totalSaved();
      if (saved > 0) h += '<div class="save-row"><span>Mengenrabatt gespart</span><span>−' + eur(saved) + "</span></div>";
      h += '<div class="total"><span>Gesamt</span><span>' + eur(grandTotal()) + "</span></div>";
      // Zusätzlicher Aktions-Rabatt (Code) — im Warenkorb zeigt Shopify Code-Rabatte nicht,
      // darum hier transparent als Anreiz ausweisen (wird an der Kasse automatisch abgezogen).
      if (discountCode && discountPercent > 0 && grandTotal() > 0) {
        var kbSaved = r2(grandTotal() * discountPercent / 100);
        h += '<div class="kb-extra">' +
          '<div class="kb-extra__row"><span>🎁 ' + discountPercent + ' % Kaufberater-Rabatt <small>(automatisch an der Kasse)</small></span><span>−' + eur(kbSaved) + "</span></div>" +
          '<div class="kb-extra__final"><span>Dein Preis an der Kasse</span><span>' + eur(r2(grandTotal() - kbSaved)) + "</span></div>" +
        "</div>";
      }
      h += "</div>";

      (res.warnungen || []).forEach(function (w) { h += '<div class="box warn">' + esc(w) + "</div>"; });
      if ((res.passt_fuer || []).length || (res.passt_nicht_fuer || []).length) {
        h += '<div class="lists">';
        if ((res.passt_fuer || []).length) h += '<div class="ok"><div class="t">✅ Passt für</div><ul>' +
          res.passt_fuer.slice(0, 5).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>";
        if ((res.passt_nicht_fuer || []).length) h += '<div class="no"><div class="t">✗ Passt nicht für</div><ul>' +
          res.passt_nicht_fuer.slice(0, 4).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>";
        h += "</div>";
      }
      h += faqBlock();
      var ci = cartItems();
      h += '<button class="btn cta" id="pa-checkout">Direkt zur Kasse</button>';
      h += ci.length
        ? '<p class="note">Bezahle sofort mit PayPal, Kreditkarte, Klarna &amp; Co. — die oben gewählten Positionen &amp; Mengen werden direkt in die Kasse übernommen.</p>'
        : '<p class="note">Der 1-Klick-Kauf ist im echten Shop aktiv (dort liefern die Produkte ihre Varianten-IDs).</p>';
      h += '<button class="btn buy2" id="pa-cart" style="margin-top:10px">In den Warenkorb legen</button>';
      if (ci.length) h += '<p class="note">Lieber erst prüfen? Hier landen die Positionen im Warenkorb zum Anpassen.</p>';
      h += '<button class="btn sec" id="pa-back" style="margin-top:10px">← Ein Schritt zurück</button>';
      h += again();
      $stage.innerHTML = h;

      // INP-Fix (08.08.2026) — Knoepfe EINMAL verdrahten statt bei jedem Klick neu.
      // Vorher: jeder Klick auf +/−/entfernen rief renderResult(), das den ganzen Block
      // per innerHTML neu baute UND danach 4x querySelectorAll ueber das frische DOM lief,
      // um alle Knoepfe neu zu binden — alles synchron IM Klick-Handler. Genau das misst
      // Google als INP (Reaktionszeit auf Klick); auf dem Handy dreistellige Millisekunden.
      // Jetzt: ein einziger delegierter Handler am stabilen #pa-stage. $stage selbst wird
      // nie ersetzt (nur seine Kinder via innerHTML), die Bindung ueberlebt jedes Rendern.
      // Die vier Attribute existieren ausschliesslich auf dieser Ergebnisseite (geprueft),
      // der Handler kann also in keiner anderen Ansicht falsch feuern.
      if (!$stage.__paDelegated) {
        $stage.__paDelegated = true;
        $stage.addEventListener("click", function (ev) {
          var t = ev.target;
          if (!t || !t.closest) return;
          var b = t.closest("[data-color],[data-inc],[data-dec],[data-rm]");
          if (!b || !$stage.contains(b)) return;
          var v;
          // Achtung: getAttribute liefert bei data-inc="0" den String "0" -> gegen null
          // pruefen, nicht auf Wahrheitswert (sonst faellt die erste Position durch).
          if ((v = b.getAttribute("data-color")) !== null) {
            // Der aktive Farbknopf traegt die Klasse "on" (s.o. Zeile mit `var on = …`).
            // Damit ersetzt die Klasse den frueheren Vergleich gegen activeColor, der
            // hier ausserhalb des Renderlaufs nicht mehr zur Verfuegung steht.
            if (b.classList.contains("on")) return;
            state.color = v; submit(); return;
          }
          if ((v = b.getAttribute("data-inc")) !== null) { state.lines[+v].count++; renderResult(); return; }
          if ((v = b.getAttribute("data-dec")) !== null) { var l = state.lines[+v]; if (l.count > 1) { l.count--; renderResult(); } return; }
          if ((v = b.getAttribute("data-rm")) !== null) { state.lines[+v].removed = true; renderResult(); }
        });
      }
      wire();
    }

    function faqBlock() {
      var fall = engine.getFall(state.caseId) || {};
      var faq = fall.faq || [];
      if (!faq.length) return "";
      var h = '<div class="faqbox"><div class="faqh">Gut zu wissen</div>';
      faq.forEach(function (f) {
        h += '<details class="faqi"><summary>' + esc(f.q) + '</summary><div class="faqa">' + esc(f.a) + "</div></details>";
      });
      return h + "</div>";
    }

    function again() { return '<button class="btn sec" id="pa-restart" style="margin-top:10px">Neue Beratung</button>'; }
    function wire() {
      var rs = byId("pa-restart"); if (rs) rs.onclick = function () { renderEntry(); };
      var co = byId("pa-checkout"); if (co) co.onclick = function () { checkout(co); };
      var c = byId("pa-cart"); if (c) c.onclick = function () { addToCart(c); };
      // Ergebnisseite: 1 Schritt zurück zum Mengen-/Flächen-Schritt (Chef 09.07.).
      var bk = byId("pa-back"); if (bk) bk.onclick = function () { render(); };
    }

    // --- Tracking: Berater-Nutzung + Schritt-Trichter messbar machen ---------
    // (1) Clarity-Custom-Tag "kaufberater" (letzte erreichte Stufe) + "kaufberater_detail"
    //     (z.B. gewaehltes Thema / Frage-Nr.) -> Sessions in Clarity gezielt filterbar
    //     (genau die Absprung-Sessions als Replay ansehen — ersetzt die fuer ein 1-URL-Quiz
    //     unbrauchbare Heatmap).
    // (2) GA4/GTM-dataLayer-Event -> falls Tag-Manager aktiv, Funnel/Conversion auch in GA4.
    // (3) Direktes GA4-Event via gtag (gtag ist im Theme aktiv, GA4 G-2HQ5CGCG7K ist gtag-Ziel).
    //     Nur der dataLayer-Push (2) allein erreichte GA4 NIE (kein GTM-Trigger dafuer) -> 0 Events.
    // Schritt-Trichter (distinkte Event-Namen, in GA4-Explorativ als Funnel lesbar):
    //   start -> thema_gewaehlt(detail=case_id) -> frage_beantwortet(detail=case_id:qN)
    //   -> menge_berechnet(case_id) -> beratung_genutzt(=Ergebnis gesehen)
    //   -> warenkorb / checkout / beratung_kontakt_gesendet.
    // So wird sichtbar WO abgesprungen wird (welches Thema, welche Frage) statt nur die Endpunkte.
    // Alle fail-silent; feuern nur, wenn das jeweilige Tool geladen ist (Consent-abhängig).
    // Kein PII: detail traegt nur case_id + Schritt-Nummer, nie Kundeneingaben.
    function paTrack(action, detail) {
      try {
        if (window.clarity) {
          window.clarity("set", "kaufberater", action);
          if (detail != null) window.clarity("set", "kaufberater_detail", String(detail));
        }
      } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: "kaufberater", kb_action: action, kb_detail: detail == null ? "" : String(detail) }); } catch (e) {}
      try {
        if (typeof window.gtag === "function") {
          var evt = { start: "kaufberater_start", thema_gewaehlt: "kaufberater_thema",
                      frage_beantwortet: "kaufberater_frage", menge_berechnet: "kaufberater_menge",
                      beratung_genutzt: "kaufberater_geoeffnet", warenkorb: "kaufberater_warenkorb",
                      checkout: "kaufberater_checkout", beratung_kontakt_gesendet: "kaufberater_kontakt" }[action]
                    || ("kaufberater_" + action);
          var params = { kb_action: action };
          if (detail != null) params.kb_detail = String(detail);
          window.gtag("event", evt, params);
        }
      } catch (e) {}
      // (4) Shopify-Web-Pixel-Bruecke: window.gtag/fbq im Theme erreichen die
      //     Shopify-Pixel NICHT (die laufen in Shopifys abgeschottetem Web-Pixel-
      //     Sandkasten). Der einzige Weg hinein ist Shopify.analytics.publish. Ein
      //     Custom Pixel (Shopify-Admin -> Einstellungen -> Kundenereignisse) hoert
      //     per analytics.subscribe("kaufberater_step") und leitet an den echten
      //     Meta-Pixel (814028647086048) + GA4 weiter. Consent-sicher (Custom Pixel
      //     feuert erst nach Einwilligung), kein Doppelzaehlen (eigenes Custom-Event).
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
          window.Shopify.analytics.publish("kaufberater_step", { kb_action: action, kb_detail: detail == null ? "" : String(detail) });
        }
      } catch (e) {}
    }

    // Aktions-Rabattcode für den Direkt-zur-Kasse-Weg anwenden. Shopifys offizieller
    // Weg ist /discount/<code>?redirect=<ziel> — dieser setzt den Rabatt zuverlässig und
    // leitet weiter. (?discount= an /checkout wird NICHT zuverlässig angewendet.)
    function withDiscount(url) {
      if (!discountCode) return url;
      return "/discount/" + encodeURIComponent(discountCode) + "?redirect=" + encodeURIComponent(url);
    }
    // Rabattcode als Warenkorb-Cookie setzen (für den "In den Warenkorb"-Weg, wo der
    // Kunde später selbst zur Kasse geht). Shopifys /discount/<code> setzt das Cookie.
    function applyDiscountCookie() {
      if (!discountCode) return;
      try { fetch("/discount/" + encodeURIComponent(discountCode), { redirect: "manual" }).catch(function () {}); } catch (e) {}
    }

    // --- Warenkorb-Add: bewusst per XMLHttpRequest, NICHT per fetch -----------
    // Grund (Diagnose 2026-07-16, Live-Playwright): die AddToCart-Erkennung des Shop-Trackings
    // (u.a. Meta) haengt an XMLHttpRequest.open. Ein fetch-Add laeuft daran VORBEI -> es entsteht
    // KEIN AddToCart-Signal (weder Browser-Pixel noch server-seitige CAPI). Deshalb geht der Add
    // ueber XHR (gleiche URL/Body wie zuvor, nur der Transport wechselt) -> derselbe getrackte Pfad
    // wie ein normaler Produktseiten-Add. Kein rohes fbq, keine Doppelzaehlung.
    // Verifikation via Meta Events-Manager (Test-Events) steht vor dem Publish noch aus.
    // Gibt ein Promise zurueck: resolve bei HTTP 2xx, sonst reject (UI-Fallback unveraendert).
    function cartAddTracked(items) {
      return new Promise(function (resolve, reject) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", cartAddUrl, true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("Accept", "application/json");
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) resolve(xhr);
            else reject(new Error("HTTP " + xhr.status));
          };
          xhr.onerror = function () { reject(new Error("network")); };
          xhr.send(JSON.stringify({ items: items }));
        } catch (e) { reject(e); }
      });
    }

    // --- Warenkorb (nativ, same-origin) -------------------------------------
    function addToCart(btn) {
      var items = cartItems();
      if (!items.length) { btn.textContent = "✓ Im echten Shop landet alles im Warenkorb"; btn.disabled = true; return; }
      btn.disabled = true; btn.textContent = "Lege in den Warenkorb…";
      cartAddTracked(items)
        .then(function () {
          // Bestell-Kennzeichen auf Warenkorb-Ebene -> landet als "Herkunft: Kaufberater"
          // in den Zusatzdetails JEDER daraus entstehenden Bestellung (Admin/Export, harte Zahl).
          try {
            var upd = (cartAddUrl || "/cart/add.js").replace("add.js", "update.js");
            fetch(upd, { method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: { "Herkunft": "Kaufberater" } }) });
          } catch (e) {}
          applyDiscountCookie();   // Aktions-Rabatt gilt auch beim späteren Selbst-Checkout
          paTrack("warenkorb");
          try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
          // Warenkorb-Sidebar statt /cart-Vollseite (Chef-Wunsch 08.07.):
          // Impulse-Cart-Drawer hoert auf 'ajaxProduct:added' -> baut Warenkorb neu auf UND oeffnet die Sidebar.
          // Fallback auf /cart-Redirect nur, falls kein Drawer aktiv ist (cart_type != drawer).
          var hasDrawer = document.querySelector("#CartDrawer");
          if (hasDrawer) {
            try { document.dispatchEvent(new CustomEvent("ajaxProduct:added")); } catch (e) {}
            btn.textContent = "✓ Im Warenkorb"; btn.disabled = false;
            btn.onclick = function () { document.dispatchEvent(new CustomEvent("cart:open")); };
          } else {
            btn.textContent = "✓ Im Warenkorb — weiter zur Kasse"; btn.disabled = false;
            btn.onclick = function () { window.location.href = cartUrl; };
          }
        })
        .catch(function () { btn.textContent = "Warenkorb nur im echten Shop verfügbar"; });
    }

    // --- Direkt zur Kasse (Warenkorb füllen -> /checkout; PayPal/Klarna/Karte als Express dort) --
    // Bewusst KEIN nativer PayPal-Button auf der Ergebnisseite: Shopifys Express-Button (show_dynamic_checkout)
    // kann nur EINE Variante -> taugt nicht fuer die Mehr-Produkt-Empfehlung. Deshalb Cart fuellen + /checkout,
    // wo Shopify PayPal & Co. automatisch als Express-Zahlarten ganz oben anbietet.
    function checkout(btn) {
      var items = cartItems();
      if (!items.length) { btn.textContent = "✓ Im echten Shop geht es direkt zur Kasse"; btn.disabled = true; return; }
      btn.disabled = true; btn.textContent = "Weiter zur Kasse…";
      cartAddTracked(items)
        .then(function () {
          // Gleiches Herkunfts-Kennzeichen wie im Warenkorb-Weg -> Bestell-Attribution bleibt erhalten.
          var upd = (cartAddUrl || "/cart/add.js").replace("add.js", "update.js");
          return fetch(upd, { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { "Herkunft": "Kaufberater" } }) }).catch(function () {});
        })
        .then(function () { paTrack("checkout"); window.location.href = withDiscount(checkoutUrl); })
        .catch(function () { btn.disabled = false; btn.textContent = "Kasse nur im echten Shop verfügbar"; });
    }
  }

  function initAll() {
    var mounts = document.querySelectorAll(".plid-advisor[data-advisor-src]");
    Array.prototype.forEach.call(mounts, initMount);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();









